<h3 *ngIf="showLocations.length > 0" class="flex flex--middle font-body-1 ms-small-x">
  <span class="flex flex--space-between fill">
    <span>
      <ng-container *ngFor="let cityName of showLocations; last as isLast">
        {{ cityName | titlecase }}<ng-container *ngIf="!isLast"> - </ng-container>
      </ng-container>
    </span>
    <span *ngIf="operatedByText"> {{ operatedByText }}</span>
  </span>
  <ng-content></ng-content>
</h3>
